import React from 'react';

import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import {
  EventCalendar,
  EventReservedTickets,
} from 'app/pages/TicketSalePage/slice/types';
import { DateTime } from 'luxon';
import { dayColorsBasedOnStatus, getDayStatusOnCalendar } from 'utils/calendar';
import { useCalendarController } from './calendarContext';

const CalendarDay = (
  props: PickersDayProps<DateTime> & {
    calendar?: EventCalendar; // didn't find out why we have to mark these props as conditional
    reservedTickets?: EventReservedTickets;
    now?: DateTime;
    handleClose?: () => void;
  },
) => {
  const {
    calendar,
    reservedTickets,
    now,
    day,
    outsideCurrentMonth,
    handleClose,
    ...other
  } = props;
  const dayIsInThePast = day < (now as DateTime);

  const { handleDateChange } = useCalendarController();

  const dayStatus = dayIsInThePast
    ? 'unavailable'
    : getDayStatusOnCalendar(
        calendar as EventCalendar,
        reservedTickets as EventReservedTickets,
        day,
      );

  const isDisabled =
    dayIsInThePast || dayStatus === 'unavailable' || dayStatus === 'sold-out';

  const handleClick = () => {
    if (isDisabled) return;

    handleDateChange(day);
    if (handleClose) {
      handleClose();
    }
  };

  return (
    <div
      key={props.day.toString()}
      style={{ position: 'relative' }}
      onClick={handleClick}
    >
      <PickersDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        disabled={isDisabled}
        sx={{
          '&': {
            color: 'var(--neutral-1000)',
          },
          '&.Mui-disabled': {
            background: 'var(--neutral-20)',
          },
          '&:not(.Mui-disabled)': {
            background: 'var(--neutral-0) !important',
          },
          '&.Mui-selected': {
            border: '1px solid var(--neutral-600)',
            transitionProperty: 'border',
            color: 'var(--neutral-1000)',
          },
        }}
      />
      {outsideCurrentMonth || dayStatus === 'unavailable' ? null : (
        <div
          style={{
            width: '16px',
            height: '2px',
            position: 'absolute',
            bottom: '6px',
            left: 0,
            right: 0,
            margin: '0 auto',
            background: `var(--${dayColorsBasedOnStatus[dayStatus]}-1000)`,
          }}
        />
      )}
    </div>
  );
};

export default CalendarDay;
